module.exports = __webpack_public_path__ + "media/applicants/device_signup_6-au-b42902f4.webp";